import { ArticleRounded } from "@mui/icons-material"
import { Chip, IconButton, Tooltip } from "@mui/material"
import dayjs from "dayjs"
import { numberFormat } from "utils"
import { PAYROLL_STS } from "./initData"

const amntFormatter = ({ value }) => value == null ? "-" : numberFormat(value)

// Render the dynamic expense columns supplied by the backend (getPayrolls -> expColumns).
// Individual type-20/21 columns are editable so an operator can add an amount even when the
// driver has no line yet; summed type columns (e.g. ค่าเที่ยว) are read-only. Amounts are
// flat fields on the row (exp_<ExpId> / typ_<ExpTypId>), so editing writes straight to them.
// kind 'dscp' columns carry the line's หมายเหตุ (pc_item.Dscp) as free text — currently only
// หักอื่นๆ has one; the rest are amounts.
const expenseColumns = (expCols) => expCols.map((c) => c.kind === "dscp" ? ({
  field: c.key, headerName: c.label, width: 160, sortable: false, editable: !!c.editable,
  cellClassName: c.InOutTyp === "I" ? "exp-deduct" : "",
}) : ({
  field: c.key, headerName: c.label, width: 95, align: "right", headerAlign: "right", type: "number",
  sortable: false, editable: !!c.editable,
  cellClassName: c.InOutTyp === "I" ? "exp-deduct" : "",
  valueFormatter: ({ value }) => (value == null || value === "" || value === 0) ? "" : numberFormat(value),
}))

export const driverSalaryColumns = (handleOpenDetail, expCols = []) => [
  {
    field: "ShowDetail", headerName: "", width: 50, align: "center", sortable: false,
    renderCell: ({ row }) => row.id === 0 ? null : (
      <Tooltip title="รายละเอียดเงินเดือน" placement="top">
        <IconButton size="small" sx={{ p: 0 }} onClick={() => handleOpenDetail(row)}>
          <ArticleRounded color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
  { field: "DrvCd", headerName: "รหัส", width: 70 },
  { field: "DrvNm", headerName: "พนักงานขับรถ", width: 180 },
  {
    field: "PayrollSts", headerName: "สถานะ", width: 110, align: "center",
    renderCell: ({ row, value }) => {
      if (row.id === 0) return null
      const s = PAYROLL_STS[value] || PAYROLL_STS[0]
      return <Chip size="small" color={s.color} label={s.label} />
    },
  },
  // trip-leg counts (from the trip wage lines) + fuel litres — supplied by getPayrolls
  // { field: "NumSts1", headerName: "รับ", width: 45, align: "center", sortable: false },
  { field: "NumSts3", headerName: "ส่ง", width: 45, align: "center", sortable: false },
  // { field: "NumSts4", headerName: "พัก", width: 45, align: "center", sortable: false },
  // { field: "NumSts5", headerName: "คืน", width: 45, align: "center", sortable: false },
  {
    field: "SumLitr", headerName: "น้ำมัน(ลิตร)", width: 85, align: "right", type: "number",
    valueFormatter: amntFormatter,
  },
  ...expenseColumns(expCols),
  {
    field: "TotEarnAmnt", headerName: "รายได้รวม", width: 110, align: "right", type: "number",
    valueFormatter: amntFormatter,
  },
  {
    field: "TotDeAmnt", headerName: "หักรวม", width: 100, align: "right", type: "number",
    valueFormatter: amntFormatter,
  },
  // advance draws (ExpId 79) — informational deduction column (from getPayrolls)
  {
    field: "AdvTripAmnt", headerName: "เบิกเบี้ยเลี้ยงล่วงหน้า", width: 130, align: "right", type: "number",
    cellClassName: "exp-deduct", valueFormatter: amntFormatter,
  },
  {
    field: "NetAmnt", headerName: "สุทธิ", width: 110, align: "right", type: "number",
    valueFormatter: amntFormatter,
  },
  // running balance (from getPayrolls) — accumulated deposit
  {
    field: "AccuDeSecDepAmnt", headerName: "หักเงินประกัน(สะสม)", width: 130, align: "right", type: "number",
    valueFormatter: amntFormatter,
  },
  {
    // PayTm starts at month-01 and only becomes the real pay date at payPayroll, so a งวด that
    // hasn't been paid yet must not show a date it was never paid on
    field: "PayDte", headerName: "วันที่จ่าย", width: 100,
    renderCell: ({ row, value }) =>
      (row.PayrollSts === 3 && value) ? dayjs(value).format("DD/MM/YYYY") : "-",
  },
  { field: "PayRef", headerName: "อ้างอิงจ่าย", width: 130 },
]
